<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.salesTargets'), $t('text.list')]">
        <el-button
          v-if="Permit.canActionsChargeEdition('salesTargetManage')"
          type="success"
          size="mini"
          @click="$router.push('/normal/sales-targets/new')"
        >
          + {{ $t("text.create") }}
        </el-button>
      </breadcrumb>
    </div>

    <div class="search">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <date
          v-model.trim="searchForm"
          type="month"
          field="month"
          :placeholder="$t('text.month')"
        />
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        :loading="loading"
        id="usersTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="month"
          :title="$t('salesTarget.month')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span class="blue" @click="showRow(row)"> {{ row.month }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="target"
          :title="$t('salesTarget.target')"
          min-width="140"
        >
          <template v-slot="{ row }">
            <currency :code="row.currency"></currency>
            {{ row.target }}
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="complete"
          :title="$t('salesTarget.complete')"
          min-width="140"
        >
          <template v-slot="{ row }">
            <currency
              v-if="row.complete != null"
              :code="row.currency"
            ></currency>
            {{ row.complete }}
          </template>
        </vxe-table-column>

        <vxe-table-column
          :title="$t('salesTarget.completeRate')"
          min-width="140"
        >
          <template v-slot="{ row }">
            <span v-if="row.complete != null && row.target != 0">{{
              Util.toFixed(row.complete / row.target, 3)
            }}</span>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          v-if="Permit.canActionsChargeEdition('salesTargetManage')"
          width="100"
        >
          <template v-slot="{ row }">
            <el-button type="text" size="mini" @click="editRow(row)">{{
              $t("text.edit")
            }}</el-button>
            <el-button type="text" size="mini" @click="deleteRow(row)">
              {{ $t("text.delete") }}
            </el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips"></div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer>

    <drawer
      :title="$t('text.edit')"
      :visible.sync="editDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <edit :id="currentRowId" @updateData="editClose" />
    </drawer>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Currency from "@/components/Currency";
import Date from "@/components/Date";

import SalesTarget from "@/api/salesTarget.js";
import Show from "./show";
import Edit from "./edit";

export default {
  mixins: [
    page,
    table.pager,
    table.search,
    table.narrow,
    table.sorter,
    table.basic,
  ],
  components: {
    Currency,
    Date,
    Show,
    Edit,
  },
  data() {
    return {
      sorter: {
        sortBy: "salesTargets_id",
        sortIndicator: "desc",
      },

      searchForm: {
        month: null,
      },
      Util: Util,

      //
      currentRowId: null,
      currentRowIdx: null,
      showDF: false,
      editDF: false,
    };
  },
  created() {
    const self = this;
  },
  methods: {
    showRow(row) {
      this.currentRowId = row.id;
      this.showDF = true;
    },
    editRow(row) {
      this.currentRowId = row.id;
      this.editDF = true;
    },
    editClose() {
      this.loadData();
      this.editDF = false;
    },
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        SalesTarget.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    //
    dataProvider(params) {
      return SalesTarget.search(params);
    },
  },
};
</script>
<style scoped>
</style>